.root {
    composes: gridContainer from "../../styles/composable/layout.module.css";
}

.recipeAttribution {
    grid-column: var(--grid-column);
    margin-block: var(--spacer-24);
    text-align: center;

    img {
        margin-inline: auto;
    }
}
